import { useLocation } from "react-router-dom";
import Header from "../../../../Components/Header";
import PurchaseForm from "./PurchaseForm";
import { Helmet } from "react-helmet";

const EditGateEntry = () => {
  const location = useLocation();
  const { gate_id } = location.state || {}; 
  

  return (
		<>
			<Helmet>
				<title>Edit Gate Entry</title>
			</Helmet>
			<Header />
			<div className="container-fluid maindiv pt-2">
				<PurchaseForm gateId={gate_id} />
			</div>
		</>
	);
};

export default EditGateEntry;
